/// <amd-module name="Agile/Sprints/Dialog/SprintEditorCalloutWrapper" />
import * as React from "react";
import { WrappedComponent } from "VSS/Platform/Layout";
import { ICalloutProps } from "OfficeFabric/Callout";
import { IBackcompatIteration } from "Agile/Sprints/Dialog/Contracts";
import { ITeam } from "Agile/Contracts/Common";

export interface ISprintEditorCalloutWrapperProps extends ICalloutProps {
    /** The team context for the sprint editor form */
    currentTeam?: ITeam;

    /** Callback for when the iteration was created/subscribed to */
    onCompleted?: (team: ITeam, iteration: IBackcompatIteration) => void;

    /** Hide the sprint status message */
    hideStatusMessage?: boolean;
}

export class LegacySprintEditorCalloutWrapper extends React.Component<ISprintEditorCalloutWrapperProps> {
    public render(): JSX.Element {
        return (
            <WrappedComponent
                wrappedType="legacy"
                dependencies={["ms.vss-web.legacy-content"]}
                wrappedProps={{
                    componentType: "sprintCallout",
                    modules: ["Agile/Scripts/SprintsHub/SprintEditor/Components/SprintEditorCallout"],
                    ...this.props
                }}
            />
        );
    }
}
